import { Box, ClickAwayListener, Fade, Modal, Slide } from '@mui/material';
import { useEffect } from 'react';

type SideModalProps = {
    isOpen: boolean;
    children: JSX.Element;
    onClose: Function;
    onOpen?: Function;
    ariaLabel?: string;
};

const SideModal = ({ isOpen, children, onClose, onOpen, ariaLabel }: SideModalProps) => {
    useEffect(() => {
        if (isOpen) {
            onOpen && onOpen();
        } else {
            onClose && onClose();
        }
        return () => onClose && onClose();
    }, [isOpen]);

    return (
        <Modal open={isOpen} onClose={() => onClose(false)} closeAfterTransition>
            <Fade in={isOpen}>
                <Box
                    sx={{
                        width: '100vw',
                        height: '100vh',
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        zIndex: 1250,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        background: 'rgba(0, 0, 0, 0.5)',
                        paddingRight: '1.75vw',
                        visibility: !isOpen ? 'hidden' : 'visible',
                        opacity: !isOpen ? '0' : '1',
                        transition: 'all 1s'
                    }}
                >
                    <Slide direction="left" in={isOpen}>
                        <Box>
                            <ClickAwayListener onClickAway={() => onClose()}>
                                <Box
                                    role="dialog"
                                    aria-modal="true"
                                    aria-label={ariaLabel}
                                    sx={{
                                        width: '100%',
                                        maxWidth: '520px',
                                        height: '98dvh',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        background: '#FFF',
                                        padding: '20px',
                                        overflow: 'auto'
                                    }}
                                >
                                    {children}
                                </Box>
                            </ClickAwayListener>
                        </Box>
                    </Slide>
                </Box>
            </Fade>
        </Modal>
    );
};

export default SideModal;
